import {DrawerForm, ProFormText, } from "@ant-design/pro-components";
import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {Button, Form, message} from "antd";
import FormUtil from "../../utils/FormUtil";
import FetchUtil from "../../utils/FetchUtil";
import MyProFormItems from "../../components/MyProFormItems";
import MyProPreviewer from "../../components/MyProPreviewer";
import {EyeFilled} from "@ant-design/icons";

const BlogCrawlEditor = (props : any, ref: any) => {

    const previewRef = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [formRef] = Form.useForm();
    const [openForm, setOpenForm] = useState(false);
    const [info, setInfo] = useState<any | undefined>({});

    let isChanged = false;

    useImperativeHandle(ref, () => {
        return {
            openEditor: (r: any) => openEditor(r)
        }
    });
    const openEditor = async (r: any) => {
        formRef.resetFields();
        setLoading(true);
        setOpenForm(true);
        isChanged = false;

        if (r?.id && r.id !== 0) {
            const res = await FetchUtil.awaitFetch("/mallApi/blog/crawlDetail",
                {id: r.id});
            if (res.code === 200) {
                setInfo(res.data);
                formRef.setFieldsValue(res.data);
            }
        } else {
            setInfo(r);
            formRef.setFieldsValue(r);
        }
        setLoading(false);
    }

    const closeEditor = () => {
        const doClose = (open: boolean) => {
            setOpenForm(open);
            setInfo({});
        }
        FormUtil.close(isChanged, doClose);
    }

    const submitForm = async (values: any) => {
        // console.log(values);
        let required = '';
        for (let col in props.columns) {
            const column = props.columns[col];
            if (column.required && (!values[column['dataIndex']] || values[column['dataIndex']].trim() === '')) {
                required += column['title'] + ' ';
            }
        }
        if (required !== '') {
            message.success("请填写必填项：" + required + '！')
            return;
        }
        const res = await FetchUtil.awaitFetch('/mallApi/blog/crawlEdit', [values]);
        if (res.code === 200) {
            isChanged = false;
            closeEditor();
            message.success("保存成功！")
            if (props.callback) {
                props.callback();
            }
        }
    }

    return (
        <DrawerForm width={980}
                    loading={loading}
                    form={formRef}
                    open={openForm}
                    colon={false}
                    labelCol={{span: 4, offset: 0}}
                    title={"Blog Crawl Editor"}
                    layout="horizontal"
                    grid={true}
                    drawerProps={{onClose: closeEditor, forceRender: false}}
                    onFinish={submitForm}
                    onChange={() => isChanged = true}
                    submitter={{
                        render: (props, defaultDoms) => {
                            return [
                                <Button onClick={() => {(previewRef.current as any).openPreviewer()}}>
                                    <EyeFilled /> 效果预览
                                </Button>,
                                <>&nbsp; &nbsp;</>,
                                ...defaultDoms,
                            ];
                        },
                    }}
        >
            <MyProFormItems columns={props.columns} formRef={formRef} info={info}/>

            <ProFormText name={"id"} hidden={true}/>

            <MyProPreviewer ref={previewRef}
                details={{title: info.blogTitle, image: info.blogImage, content: info.blogContent}} />

        </DrawerForm>
    )
}

export default forwardRef(BlogCrawlEditor)
